import Vue from 'vue';
import i18nApi from '@checkout/i18n/translateService';

Vue.filter('priceFilter', function (value) {
    if (!value) return '';

    let prices = value.split(',');

    if (prices[1]) {
        return (
            'CHF&nbsp;' +
            prices[0] +
            '.' +
            prices[1].replace('00', '-') +
            '/' +
            i18nApi.t('mo')
        );
    }

    return 'CHF&nbsp;' + prices[0].replace('.00', '.-') + '/' + i18nApi.t('mo');
});

Vue.filter('priceFilterWithoutMo', function (value) {
    if (!value) return '';

    let prices = value.split(',');

    if (prices[1]) {
        return (
            'CHF&nbsp;' +
            prices[0] +
            '.' +
            prices[1].replace('00', '-')
        );
    }

    return 'CHF&nbsp;' + prices[0].replace('.00', '.-')
});

Vue.filter('priceFilter2', function (value) {
    if (!value) return 0;

    let prices = value.split(',');

    if (prices[1]) {
        return prices[0] + '.' + prices[1].replace('00', '-') + '/' + i18nApi.t('mo');
    }

    return (
        prices[0].replace('.00', '.-') + '/' + i18nApi.t('mo')
    );
});

Vue.filter('priceFilterTv2', function (value) {
    if (!value) return '';

    let prices = value.split(',');

    if (prices[1]) {
        return (
            prices[0] +
            '.' +
            prices[1].replace('00', '-') +
            '/' +
            i18nApi.t('checkout1Right.activation')
        );
    }

    return (
        prices[0].replace('.00', '.-') +
        '/' +
        i18nApi.t('checkout1Right.activation')
    );
});

Vue.filter('priceFilterTv', function (value) {
    if (!value) return '';

    let prices = value.split(',');

    if (prices[1]) {
        return '&nbsp;' + prices[0] + '.' + prices[1].replace('00', '-');
    }

    return '&nbsp;' + prices[0].replace('.00', '.-');
});

Vue.filter('uppercase', function (value) {
    return value.toUpperCase()
})
